// Small DOM helpers shared by the views.
import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { MAP_CENTER, MAP_BOUNDS } from './config.js';

// Bundled marker images (Leaflet's defaults break under bundlers).
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconUrl: markerIcon, iconRetinaUrl: markerIcon2x, shadowUrl: markerShadow });

export const $ = (sel, root = document) => root.querySelector(sel);
export const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

export function esc(s) {
  return String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

let toastTimer;
export function toast(msg, ms = 3000) {
  const el = $('#toast');
  el.textContent = msg; el.hidden = false;
  clearTimeout(toastTimer); toastTimer = setTimeout(() => { el.hidden = true; }, ms);
}

export function setBanner(html) {
  const el = $('#banner');
  el.innerHTML = html || ''; el.hidden = !html;
}

/** Runs an async action with a busy button and a toast on error. */
export async function busy(btn, fn) {
  const label = btn?.textContent;
  if (btn) { btn.disabled = true; btn.textContent = '…'; }
  try { return await fn(); }
  catch (e) { toast(e.message || String(e), 5000); throw e; }
  finally { if (btn) { btn.disabled = false; btn.textContent = label; } }
}

const TILE_URL = import.meta.env.VITE_TILE_URL || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

/** Creates a Leaflet map inside el, limited to Bengaluru. */
export function makeMap(el) {
  const bounds = L.latLngBounds(MAP_BOUNDS);
  const map = L.map(el, { maxBounds: bounds.pad(0.3), minZoom: 10 }).setView(MAP_CENTER, 12);
  L.tileLayer(TILE_URL, { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(map);
  // Views are re-rendered into a new container; make sure Leaflet measures it after layout.
  let gone = false;
  setTimeout(() => { if (!gone) map.invalidateSize(); }, 50);
  // Safe teardown when leaving a screen (stops running pan/zoom animations first).
  // _animatingZoom=false makes Leaflet's delayed zoom-end timer a no-op after removal.
  map.destroy = () => { gone = true; map.stop(); map._animatingZoom = false; map.off(); map.remove(); };
  return map;
}

export function numberIcon(label, color) {
  return L.divIcon({
    html: `<div style="background:${color};color:#fff;width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:12px;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4)">${esc(label)}</div>`,
    className: '', iconSize: [28, 28], iconAnchor: [14, 14],
  });
}

export function statusChip(status) {
  return `<span class="chip ${esc(status)}">${esc(status)}</span>`;
}

export { L };
